// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceType } from './IInvoiceType';
import {
    IInvoiceTypeFromJSON,
    IInvoiceTypeFromJSONTyped,
    IInvoiceTypeToJSON,
    IInvoiceTypeToJSONTyped,
} from './IInvoiceType';

/**
 * 
 * @export
 * @interface IUnappliedPushInvoiceDto
 */
export interface IUnappliedPushInvoiceDto {
    /**
     * 
     * @type {number}
     * @memberof IUnappliedPushInvoiceDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {IInvoiceType}
     * @memberof IUnappliedPushInvoiceDto
     */
    invoice_type?: IInvoiceType;
    /**
     * 
     * @type {Date}
     * @memberof IUnappliedPushInvoiceDto
     */
    invoice_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IUnappliedPushInvoiceDto
     */
    amount?: number;
}



/**
 * Check if a given object implements the IUnappliedPushInvoiceDto interface.
 */
export function instanceOfIUnappliedPushInvoiceDto(value: object): value is IUnappliedPushInvoiceDto {
    return true;
}

export function IUnappliedPushInvoiceDtoFromJSON(json: any): IUnappliedPushInvoiceDto {
    return IUnappliedPushInvoiceDtoFromJSONTyped(json, false);
}

export function IUnappliedPushInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUnappliedPushInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_type': json['invoice_type'] == null ? undefined : IInvoiceTypeFromJSON(json['invoice_type']),
        'invoice_date': json['invoice_date'] == null ? undefined : (new Date(json['invoice_date'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IUnappliedPushInvoiceDtoToJSON(json: any): IUnappliedPushInvoiceDto {
    return IUnappliedPushInvoiceDtoToJSONTyped(json, false);
}

export function IUnappliedPushInvoiceDtoToJSONTyped(value?: IUnappliedPushInvoiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_type': IInvoiceTypeToJSON(value['invoice_type']),
        'invoice_date': value['invoice_date'] == null ? undefined : ((value['invoice_date']).toISOString()),
        'amount': value['amount'],
    };
}

